module.exports = __webpack_public_path__ + "static/img/2050-1.c216255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/2050-1.jpg
// module id = wu1N
// module chunks = 0